import { ChangeDetectorRef, Component } from '@angular/core'
import { CellComponent } from '@spartacus/organization/administration/components'
import { OutletContextData, TableDataOutletContext } from '@spartacus/storefront'
import {Observable} from "rxjs";
import {EbProduct} from '../../interfaces/eb-product.interface'
import {EbProductService} from "../../services/facades/eb-product.service";

@Component({
    selector: 'eb-product-variants-table-actions',
    templateUrl: './eb-product-variants-table-actions.component.html',
    styleUrls: ['eb-product-variants-table-actions.component.scss'],
    standalone: false
})
export class EbProductVariantsTableActionsComponent extends CellComponent {
  isDisabled: boolean

  constructor(
    outlet: OutletContextData<TableDataOutletContext>,
    protected cd: ChangeDetectorRef,
    private ebProductService: EbProductService,
  ) {
    super(outlet)
    this.isDisabled = false
  }

  get product(): Observable<EbProduct> {
    return this.ebProductService.get(this.item.code);
  }

  stopParentFunction(event: any) {
    event.stopPropagation()
  }
}
